

export enum IndicatorStatus {
    NotComplete, Completed
}
export class Indicator {
    constructor(public id: string,
        public key: string,
        public icon: string,
        public order: number
    ) { }

    status?: IndicatorStatus;
    domains: IndicatorDomain[] = [];

    // Calculated
    isCached = false;
    attachmentsFormKey = false;
    requestId: string;
    submissionId: string;
    resultSubmissionId: string;
}

export class IndicatorDomain {
    constructor(public id: string,
        public key: string,
        public domainNumber: string,
        public description: string,
        public order: number) { }

    notes: string;
    recommendations: string;
    decision?: IndicatorStatus;
    questions: IndicatorQuestions[] = [];
    attachments: any[] = [];
    attachmentsInstance: any[] = [];

    // Calculated
    resultSubmissionId: string;
}

export class IndicatorQuestions {
    constructor(public id: string,
        public order: number,
        public description: string,
        public key: string,
        public domainKey: string
    ) { }

    answer: number;
}